import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class TableSkeletonService {
    /**
     * Флаг включения скелетона
     */
    skeletonShow: boolean = false;

    /**
     * Режим одной полосы
     */
    isOneLineSkeleton: boolean = false;

    constructor() {}

    /**
     * Показать скелетон
     */
    show() {
        this.skeletonShow = true;
    }

    /**
     * Скрыть скелетон
     */
    hide() {
        this.skeletonShow = false;
    }

    /**
     * Скелетон одной линией
     */
    setOneLineSkeleton() {
        this.isOneLineSkeleton = true;
    }
}
